module.exports = __webpack_public_path__ + "static/media/nima_talking_tailor_dai.537e3bbd.gif";